import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4523" />
      <ArchitectureDiagram data-id="element-4524" />
      <HowItWorksConnections mode="how" data-id="element-4525" />
      <LivesInSlack data-id="element-4526" />
      <ComputerUse data-id="element-4527" />
      <CapabilityGrid data-id="element-4528" />
      <NarrativeSection data-id="element-4529" />
      <ToolComparison data-id="element-4530" />
      <WallOfLove data-id="element-4531" />
      <PricingSection data-id="element-4532" />
      <ClosingCTA data-id="element-4533" />
    </>;
}